import { render } from "./mvt-newmap.vue?vue&type=template&id=328f5bce"
import script from "./mvt-newmap.js?vue&type=script&lang=js"
export * from "./mvt-newmap.js?vue&type=script&lang=js"

import "./mvt-newmap.vue?vue&type=style&index=0&id=328f5bce&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__